import packageJson from '../../package.json';

const URL_SITE = 'https://purchasing-reports.test.sla-lilp.devtest.gf.aws.scania.com';

export const environment = {
  production: true,
  appVersion: packageJson.version + '-acp',
  dataEnv: 'DEV',
  awsRegion: 'us-east-1',
  url: {
    api_visa: 'https://acp-visa-api.br.scania.com/api/Nimbi',
    api_generic_tools: 'https://apim-br.devtest.aws.scania.com/generic-tools-api/v1/api',
    api_abaco: 'https://apim-br.devtest.aws.scania.com/abaco-compras/v1/api',
  },
  redirects: {
    redirectUrlSignIn: URL_SITE,
  },
  AZURE_API_SCOPE:'api://20314930-76aa-46a6-acd6-a348eb04bf47/access_as_user',
  AZURE_SCOPES: {
    genericTools: ['api://073c1c3c-9546-4212-b285-2aaf8e9ae793/access_as_user'],
    abaco: ['api://955028c9-2a8a-4b95-9af8-1ce6831372e8/access_as_user'],
    visa: ['api://76953d65-8800-45d9-ae1c-8a40c0da7ac4/visa-integrations']
  }
};
